import ExpandableSection from "../component/_expandableSection";

document.addEventListener('DOMContentLoaded', function () {
    const heroBlockV2Sections = document.querySelectorAll('.js-section-hero-block-v2-image-wrapper');

    if (!heroBlockV2Sections) return;

    heroBlockV2Sections.forEach((heroSection) => {

        heroSection.addEventListener('mousemove', (e) => {

            const centerX = window.innerWidth / 2;
            const centerY = window.innerHeight / 2;

            const offsetX = e.clientX - centerX;
            const offsetY = e.clientY - centerY;

            const factor = 0.03;

            const moveX = offsetX * factor;
            const moveY = offsetY * factor;

            heroSection.style.backgroundPosition = `
      calc(95% + ${moveX}px) 
      calc(50% + ${moveY}px)
    `;
        });
    });
});